import React from 'react';
import { LinkWithNativeEvents } from '@components/_common/link/link';
import { datadogRum } from '@datadog/browser-rum';
import { DateMasks, AnalyticEvents } from '../../constants';
import {
  VehicleDetailsWrapper,
  Image,
  CarInfo,
  Make,
  Model,
  Vin,
  PurchaseInfo,
  Date,
  VdpLinkWrapper,
  VdpLink,
} from './VehicleDetails.styles';
import { defaultImageHandler, formatDate, getLocalStorage } from '../../services/UtilitiesService';
import { Analytics } from '../../services/analytics-service';

const VehicleDetails = ({ vehicle, date, referenceType }: any) => {
  const { id, imageUrl, year, make, model, trim, vin } = vehicle;
  const hasClickedAddVehicleButton = getLocalStorage('hasClickedAddVehicleButton') as string;

  const trackClickEvent = () => {
    Analytics.trackEvent(AnalyticEvents.ovpVehicleImageClicked);
    datadogRum.addAction(AnalyticEvents.ovpVehicleImageClicked);
  };

  return (
    <VehicleDetailsWrapper hasClickedAddVehicleButton={hasClickedAddVehicleButton}>
      <Image
        data-testid="vehicle-card-image"
        src={imageUrl}
        alt={`${make} ${model} - ${trim}`}
        onError={defaultImageHandler}
        onClick={trackClickEvent}
      />
      <CarInfo>
        <Make data-testid="vehicle-card-make">{`${year} ${make} ${model}`}</Make>
        <Model data-testid="vehicle-card-model">{trim}</Model>
        <Vin data-testid="vehicle-card-vin">Vin: {vin}</Vin>
        <PurchaseInfo data-testid="vehichle-card-vehicle-info">
          {referenceType === 'vehicle' ? <>Purchased on </> : <>Appraised on </>}
          <Date>{formatDate(date, DateMasks.MonthDayYearForwardSlash)}</Date>
          {referenceType === 'vehicle' && (
            <VdpLinkWrapper>
              <VdpLink
                href={`/vehicle/${id}`}
                target="_blank"
                // as={VdpLink as any}
                nativeEvent={{
                  event: 'continue_to_vdp',
                  payload: {
                    url: `/vehicle/${id}`,
                    vehicleId: id,
                  },
                }}
                onClickCapture={() => Analytics.trackEvent(AnalyticEvents.ovpSeeVehicleDetailsClicked)}
              >
                See Vehicle Details
              </VdpLink>
            </VdpLinkWrapper>
          )}
        </PurchaseInfo>
      </CarInfo>
    </VehicleDetailsWrapper>
  );
};

export default VehicleDetails;
